import { Box, Typography } from '@mui/material'
import NotificationItemCard from './molecules/NotificationItemCard'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'
import { RBox } from '../__styled'
import { ActivityTypeUtil, NotificationItem } from '@/types/notification'
import { useNavigate } from 'react-router-dom'
import RequestListItem from './molecules/RequestListItem'
import { ConnectionRequest } from '@/types'
import { useMemo } from 'react'
import { groupedNotifications } from '@/utils/helper'
import PageWrapper from '@/components/PageWrapper'

export default function NotificationPage() {
  const navigate = useNavigate()
  const { markAsRead } = useAppStore()

  const [notificationItems] = useAppStore((state) => [state.notification.items], shallow)
  const [connRequests] = useAppStore((state) => [state.user.connRequests], shallow)

  const hasData = notificationItems.length > 0 || connRequests.length > 0

  const notificationGroups = useMemo(() => {
    return notificationItems.length > 0 ? groupedNotifications(notificationItems) : []
  }, [notificationItems])

  const onClickNotificationItem = (item: NotificationItem) => {
    if (ActivityTypeUtil.isTopicRelatedEvent(item.eventType)) {
      let previewQuery = new URLSearchParams()
      previewQuery.set('topicID', ActivityTypeUtil.getTopicID(item))
      previewQuery.set('topicType', item.topicType.toString())
      if (ActivityTypeUtil.isNoteLevelEvent(item.eventType)) {
        previewQuery.set('noteID', ActivityTypeUtil.getNoteID(item))
      }
      navigate(`/preview?${previewQuery.toString()}`)
    } else {
      markAsRead(item.eventID)
      let previewQuery = new URLSearchParams()
      previewQuery.set('id', item.sourceUserID)
      navigate(`/profile/user?${previewQuery.toString()}`)
    }
  }

  const onClickRequestItem = (request: ConnectionRequest) => {
    let previewQuery = new URLSearchParams()
    previewQuery.set('id', request.requestorID)
    navigate(`/profile/user?${previewQuery.toString()}`)
  }

  return (
    <PageWrapper
      title='Notifications'
      sx={{
        display: 'flex',
        width: '100%',
        overflow: 'auto',
        flexDirection: 'row',
        flex: 1,
      }}
    >
      <Box flexDirection={'column'} display={'flex'} flex={1} p={2} sx={{ gap: '10px' }}>
        {!hasData && (
          <RBox sx={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <Typography style={{ fontSize: 16, fontWeight: '400' }}>{'No messages'}</Typography>
          </RBox>
        )}

        {connRequests.map((el, idx) => (
          <RequestListItem item={el} key={`${idx}`} onClick={onClickRequestItem} />
        ))}

        {notificationGroups.map((e, idx) => (
          <NotificationItemCard
            key={`${idx}`}
            item={e}
            variant='list'
            onClick={onClickNotificationItem}
          />
        ))}
      </Box>
    </PageWrapper>
  )
}
